import DifferentiationShape from 'approot/shared/differentiation/differentiation-shape';
import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';
import { PStyled } from 'approot/shared/styles/typography.style';
import { grey7 } from 'approot/shared/styles/colours.style';
import { SimpleCardLabelTitle } from './simple-card-label.style';

type Props = {
  title: string;
  description: string | null;
  differentiation: Differentiation | null;
};

const SimpleCardLabel = ({ title, description, differentiation }: Props) => (
  <>
    <SimpleCardLabelTitle>
      <DifferentiationShape
        isSmall
        width={12}
        height={12}
        marginRight={8}
        differentiation={differentiation || Differentiation.GreenCircle}
      />
      <span>{title}</span>
    </SimpleCardLabelTitle>
    {description && (
      <PStyled as="div" colour={grey7} marginBottom={0}>
        {description}
      </PStyled>
    )}
  </>
);

export default SimpleCardLabel;
